import type { Paginated } from '@field-support/shared';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { Num } from './Num';

/** Page controls under a flush table. Hidden when everything fits on one page. */
export function Pagination({ data, onPage }: { data: Paginated<unknown>; onPage: (page: number) => void }) {
  const { t } = useTranslation();
  const pages = Math.max(1, Math.ceil(data.total / data.pageSize));
  if (data.total <= data.pageSize) return null;
  return (
    <div className="fs-pagination">
      <span>
        {t('common.page')} <Num>{data.page}</Num> / <Num>{pages}</Num> · <Num>{data.total}</Num> {t('common.items')}
      </span>
      <Button variant="secondary" size="sm" disabled={data.page <= 1} onClick={() => onPage(data.page - 1)}>
        {t('common.previous')}
      </Button>
      <Button variant="secondary" size="sm" disabled={data.page >= pages} onClick={() => onPage(data.page + 1)}>
        {t('common.next')}
      </Button>
    </div>
  );
}
